import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { streamsFilterStoreSelector } from '../streamsFilter.selector';

export const selectedStreamIdSelector = createCachedSelector(
  [
    path(streamsFilterStoreSelector).selectedStream(),
  ],
  (selectedStream) => selectedStream,
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
